function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.999 0v3.5A1.5 1.5 0 008.497 5h3.5v1.035l.002.965-4.5 4.5-1.5-1.5c-.5-.5-1.448-.552-2 0-.553.552-.5 1.5 0 2l2.045 1.998H3.499a1.5 1.5 0 01-1.5-1.5V1.5a1.5 1.5 0 011.5-1.5h3.5zm.998.25V3.5a.5.5 0 00.5.5h3.25L7.997.25z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.848 9.154a.526.526 0 010 .743l-3.94 3.939a.562.562 0 01-.792 0L4.756 11.5a.526.526 0 11.743-.743l2.013 1.99 3.592-3.593a.526.526 0 01.744 0z",
  fill: "currentColor"
});

var SvgSubmitted = function SvgSubmitted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgSubmitted;